/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Invalid/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Invalid({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientEmail/Status/Invalid"
  
}) {
  return null
}